let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f7rvX")).then(() => parcelRequire('90He8'));